import {
	SET_USER_COLUMNS,
	FILTER_CONTACTS,
	SET_CONTACT_SELECTED,
	GET_COUNTRIES,
	SELECT_CONTACT,
	GET_MESSAGE_LOG,
	SET_MESSAGE_LOG,
	SET_MESSAGE_LOG_FILTER,
	CLEAR_MESSAGE_LOG_FILTER,
	RESET_BULK_SELECTION,
	SET_TAGS,
	SET_CUSTOM_TAGS,
	DELETE_CONTACTS,
	ADD_CONTACTS_PROJECT_ENTITY
} from '../actiontypes';
import env from '../../util/env';
import {contactDBRoutes, serviceURL, Entities, TagContacts, source} from '../../util/uiconstants';

export const filterContacts = (filterData = null) => ({
	type: FILTER_CONTACTS,
	filterData
});

export const selectContact = (contactId) => ({
	type: SELECT_CONTACT,
	contactId
});

export const resetBulkSelection = () => ({
	type: RESET_BULK_SELECTION
});

export const setUserColumn = (data) => {
	return {
		type: SET_USER_COLUMNS,
		data
	};
};

export const getUserColumns = () => {
	return {
		type: SET_USER_COLUMNS
	};
};

export const getCountries = (projectId) => {
	const url = `${env.getBaseURL(serviceURL)}${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.countries}`;

	return {
		type: GET_COUNTRIES,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
};

export const setContactSelected = (data) => {
	return {
		type: SET_CONTACT_SELECTED,
		data
	};
};

export const setMessageLog = ({projectId, payload: data, userData}) => {
	const url = `${env.getBaseURL(serviceURL)}${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.messages}`;

	return {
		type: SET_MESSAGE_LOG,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		userData
	};
};

export const setMessageLogFilter = (filterItemName, value) => {
	return {
		type: SET_MESSAGE_LOG_FILTER,
		filterItemName,
		value
	};
};

export const clearMessageLogFilters = () => {
	return {
		type: CLEAR_MESSAGE_LOG_FILTER
	};
};

export const getMessageLog = (projectId) => {
	let url = `${env.getBaseURL(serviceURL)}${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.messages}`;

	return {
		type: GET_MESSAGE_LOG,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
};

export const setTags = (projectId, userIds, tagModified, operation, entityId) => {
	const url = `${env.getBaseURL(serviceURL)}${contactDBRoutes.projects}/${projectId}/${
		contactDBRoutes.entities
	}/${entityId}/${contactDBRoutes.contactProperties}`;

	const payload = {
		contactIds: Array.from(userIds),
		operation,
		tag: {
			tagId: tagModified.id
		}
	};

	return {
		type: SET_TAGS,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: payload
			}
		}
	};
};

export const setCustomTags = (projectId, tagsList, tagsData) => {
	const url = `${env.getBaseURL(serviceURL)}${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.tags}`;

	return {
		type: SET_CUSTOM_TAGS,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: tagsList
			}
		},
		tagsData
	};
};

export const deleteContacts = (projectId, entityId, payload) => {
	const url = `${env.getBaseURL(serviceURL)}${contactDBRoutes.projects}/${projectId}/${
		contactDBRoutes.entities
	}/${entityId}/${contactDBRoutes.contactsDelete}`;

	const data = {...payload, source: source.contactList};

	return {
		type: DELETE_CONTACTS,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		}
	};
};

export function addContactToEntityProject(projectId, entityId, body) {
	const getProjectUrl = (projectId, entityId) =>
		`${env.getBaseURL(serviceURL)}${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.entities}/${entityId}`;

	return {
		type: ADD_CONTACTS_PROJECT_ENTITY,
		meta: {
			api: {
				url: getProjectUrl(projectId, entityId),
				data: body,
				method: 'POST'
			}
		}
	};
}
